/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="a1174f87-678a-41ad-a722-634cee013851" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="a356db3e-0e4f-42be-bf33-58b048a46f62" x="0" y="0" width="24" height="24" maskUnits="userSpaceOnUse">
            <g id="a6139880-bdc8-4f8d-a6da-e220323a86d8">
              <path id="ad6482a4-eb90-4176-8bcd-6b5e2f3fd7ff" d="M20,21.4l-.55-.79A11.52,11.52,0,0,0,12,16.25c-3.65-.52-5.66.82-6.75,2.23A17,17,0,0,1,9.69,9.37a5.25,5.25,0,0,1,1.23,4.2l0,.14,1,.17,0-.15A6.34,6.34,0,0,0,10.73,9,3.86,3.86,0,0,1,14.55,11l.06.13.9-.45-.07-.13A4.72,4.72,0,0,0,11.1,8a5.49,5.49,0,0,1,4.25-.93l.14,0,.24-1-.15,0A6.54,6.54,0,0,0,11,6.88a5.71,5.71,0,0,0-.1-3.74L10.87,3,10,3.39l.06.14A4.94,4.94,0,0,1,10,6.9,3.8,3.8,0,0,0,6.73,4.27l-.15,0-.16,1,.14,0A2.87,2.87,0,0,1,9.19,7.81a5.9,5.9,0,0,0-4.62-.28l-.14,0,.37.93.14-.06a5,5,0,0,1,3.9.33l-.06.07-.07.08A17.85,17.85,0,0,0,4,21.22v.15h.85l.15,0,14,.06Zm-12.19-1H5.29c.5-1.29,2-3.75,6.55-3.1a10.55,10.55,0,0,1,6.07,3.16Z" fill="#fff" style={{ fillRule: 'evenodd' }}/>
            </g>
          </mask>
        </defs>
        <g id="b862d112-4d14-455b-9632-71f5d85fa8ec">
          <g id="ef93f2af-d34c-4b5d-a858-6efd95b7af9e">
            <g id="fd4ee882-5fbb-4a7e-bb3c-9aff719ce179">
              <path id="f624b725-308e-4e06-a398-2eb09d965999" d="M20,21.4l-.55-.79A11.52,11.52,0,0,0,12,16.25c-3.65-.52-5.66.82-6.75,2.23A17,17,0,0,1,9.69,9.37a5.25,5.25,0,0,1,1.23,4.2l0,.14,1,.17,0-.15A6.34,6.34,0,0,0,10.73,9,3.86,3.86,0,0,1,14.55,11l.06.13.9-.45-.07-.13A4.72,4.72,0,0,0,11.1,8a5.49,5.49,0,0,1,4.25-.93l.14,0,.24-1-.15,0A6.54,6.54,0,0,0,11,6.88a5.71,5.71,0,0,0-.1-3.74L10.87,3,10,3.39l.06.14A4.94,4.94,0,0,1,10,6.9,3.8,3.8,0,0,0,6.73,4.27l-.15,0-.16,1,.14,0A2.87,2.87,0,0,1,9.19,7.81a5.9,5.9,0,0,0-4.62-.28l-.14,0,.37.93.14-.06a5,5,0,0,1,3.9.33l-.06.07-.07.08A17.85,17.85,0,0,0,4,21.22v.15h.85l.15,0,14,.06Zm-12.19-1H5.29c.5-1.29,2-3.75,6.55-3.1a10.55,10.55,0,0,1,6.07,3.16Z" fill="#05273e" className="icon-fill"/>
            </g>
            <g style={{ mask: 'url(#a356db3e-0e4f-42be-bf33-58b048a46f62)' }}>
              <g id="e13b874a-1e8e-411a-b191-fe9cf5d1ea1b">
                <rect id="aa6045a7-79d2-4370-8036-a806abac7dbc" width="24" height="24" className="icon-fill"/>
              </g>
            </g>
            <g style={{ mask: 'url(#a356db3e-0e4f-42be-bf33-58b048a46f62)' }}>
              <rect id="a70be560-6f08-49f0-9711-2317ada1f95b" width="24" height="24" className="icon-fill"/>
            </g>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'PalmTreeIslandIcon';

export default Icon;
